import * as angular from 'angular';
import {IController, IOnChangesObject} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class AddOrRemoveSupplyAccountsTableComponent implements IController {
  accounts: AccountModel[];
  queryString?: string;
  isRemoveEnable: boolean;
  isAddEnable: boolean;
  onAddAccountsClicked: Function;
  onRemoveAccountsClicked: Function;

}

angular.module('bringoz.admin.accounts')
  .component('addOrRemoveSupplyAccountsTable', {
      bindings: {
        accounts: '<',
        queryString: '<?',
        isRemoveEnable: '<?',
        isAddEnable: '<?',
        onAddAccountsClicked: '&',
        onRemoveAccountsClicked: '&',
      },
      template: require('./add-or-remove-supply-accounts-table.html').default,
      controller: AddOrRemoveSupplyAccountsTableComponent
    }
  );
